
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6577"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6577"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2E5gs", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $1ed3669a5569bbad$export$6503ec6e8aabbaf; }, function (v) { return $1ed3669a5569bbad$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $1ed3669a5569bbad$export$f7ad0328861e2f03; }, function (v) { return $1ed3669a5569bbad$export$f7ad0328861e2f03 = v; });
var $1ed3669a5569bbad$export$6503ec6e8aabbaf;
var $1ed3669a5569bbad$export$f7ad0328861e2f03;
"use strict";
var $1ed3669a5569bbad$var$mapping = new Map();
function $1ed3669a5569bbad$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$1ed3669a5569bbad$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $1ed3669a5569bbad$var$resolve(id) {
    var resolved = $1ed3669a5569bbad$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$1ed3669a5569bbad$export$6503ec6e8aabbaf = $1ed3669a5569bbad$var$register;
$1ed3669a5569bbad$export$f7ad0328861e2f03 = $1ed3669a5569bbad$var$resolve;

});

var $188ff4585b81f7fa$exports = {};

(parcelRequire("2E5gs")).register(new URL("", import.meta.url).toString(), JSON.parse('["j2qSH","index.788a50b3.js","bx80Y","json-jsoneditor.8b03ca03.js","jAdNf","json-jsoneditor.40a52cdd.css","51xFf","jsoneditor-icons.449b2aa7.svg"]'));


//# sourceMappingURL=index.runtime.599d17e9.js.map
